(function () { 
    angular.module('invesfleet')
        .directive('notAvailable', notAvailable);
    
        notAvailable.$inject = [];
    
        function notAvailable() {
            
            return {
                restrict: 'A', 
                priority: 999, //Set order of execution to be able to unbind events set by other directives
                link: function(scope, element, attrs){

                    if(attrs.condition === 'false'){return;}
                    if(typeof attrs.dir === 'undefined'){ attrs.dir = 'bottom'; } 
                    if(typeof attrs.events === 'undefined'){ 
                        attrs.events = `blur change click dblclick error focus focusin focusout 
                        hover keydown keypress keyup load mousedown mouseenter mouseleave 
                        mousemove mouseout mouseover mouseup resize scroll select submit`; } 

                    element.addClass('tooltip-' + attrs.dir);
                    element.attr('data-tooltip', 'No disponible en esta versión');
                    element.attr('disabled', 'true');

                    var evts = attrs.events.split(' ');

                    element.off();

                    angular.forEach(evts, function(value, key) {
                        element.bind(value, function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        });
                    });

                    if(element[0].style){
                        element[0].style.display = 'none';
                    }
                    
                },
            };
        }
    })();